import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StepLayoutService } from '../step-layout/step-layout.service';
import { User } from '../../../root/services/user.service';
import { StepItem } from '../step-navigation/step-navigation.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hfc-header-with-sidebar',
  templateUrl: './header-with-sidebar.component.html',
  styleUrls: ['./header-with-sidebar.component.scss'],
  animations: [
    trigger('menu', [
      transition(':enter', [
        group([
          query('@overlay', animateChild()),
          style({ transform: 'translateX(-100%)' }),
          animate(200, style({ transform: 'translateX(0)' }))
        ])
      ]),
      transition(':leave', [
        group([query('@overlay', animateChild()), animate(200, style({ transform: 'translateX(-100%)' }))])
      ])
    ]),
    trigger('overlay', [
      transition(':enter', [style({ opacity: 0 }), animate(200, style({ opacity: 1 }))]),
      transition(':leave', [animate(200, style({ opacity: 0 }))])
    ])
  ]
})
export class HeaderWithSidebarComponent implements OnInit {
  public closeButton = false;
  public isTablet = false;

  @Input()
  public pageTitle: string;

  @Input()
  public percentageCompleted: number;

  @Input()
  public showStepNavigation = true;

  @Input()
  public user: User;

  @Input()
  public isApplicantSwitchVisible: boolean;

  @Input()
  public steps: StepItem[];

  @Input()
  public stepNameMap: Map<string, string>;

  constructor(
    public stepLayoutService: StepLayoutService,
    private route: ActivatedRoute,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    public readonly tenantConfigService: TenantConfigService
  ) {}

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .pipe(map((result) => result.matches))
      .subscribe((isTablet) => (this.isTablet = isTablet));
  }

  public onCloseButtonClicked() {
    let last = this.route.firstChild;

    if (last.firstChild) {
      last = last.firstChild;
    }

    this.router.navigate([this.stepLayoutService.closeButtonPath || '..'], {
      relativeTo: last,
      fragment: this.stepLayoutService.closeButtonFragment
    });
  }
}
